export default __webpack_public_path__ + "static/media/corrieredellasera.f2d9faa2.png";